import { render } from "./ExamManagementEdit.vue?vue&type=template&id=03dc8fc0&scoped=true"
import script from "./ExamManagementEdit.vue?vue&type=script&lang=js"
export * from "./ExamManagementEdit.vue?vue&type=script&lang=js"

import "./ExamManagementEdit.vue?vue&type=style&index=0&id=03dc8fc0&lang=scss&scoped=true"
import "./ExamManagementEdit.vue?vue&type=style&index=1&id=03dc8fc0&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03dc8fc0"]])

export default __exports__